import { Box } from 'src/design/atoms/Box';
import { Group } from 'src/design/atoms/Group';
import { Stack } from 'src/design/atoms/Stack';
import { Text } from 'src/design/atoms/Text';
import { IconThumbDownFilled, IconThumbUpFilled } from '@tabler/icons-react';
import React from 'react';
import { ChatMessageFeedbackDto } from 'src/api/FiretrolApiClient';
import {
  FEEDBACK_RATING_UP,
  feedbackReasonLabel,
} from 'src/app/chat/messageFeedback';

export interface IMessageFeedbackSummaryProps {
  feedback: ChatMessageFeedbackDto;
}

/** @registry Read-only display of a stored vote on an assistant reply (rating, reason, comment) for admin transcript views. */
export const MessageFeedbackSummary: React.FC<IMessageFeedbackSummaryProps> = ({
  feedback,
}) => {
  const isUp = feedback.rating === FEEDBACK_RATING_UP;
  const verdict = isUp ? 'Good response' : 'Bad response';
  const summary = feedback.reason
    ? `${verdict}: ${feedbackReasonLabel(feedback.reason)}`
    : verdict;

  return (
    <Group
      gap={6}
      wrap="nowrap"
      align="flex-start"
      data-testid="message-feedback-summary"
    >
      <Box
        c={isUp ? 'green.7' : 'red.7'}
        style={{ display: 'flex', flexShrink: 0, marginTop: 2 }}
      >
        {isUp ? (
          <IconThumbUpFilled size={14} aria-hidden />
        ) : (
          <IconThumbDownFilled size={14} aria-hidden />
        )}
      </Box>
      <Stack gap={2} style={{ minWidth: 0 }}>
        <Text size="xs" c="bright">
          {summary}
        </Text>
        {feedback.comment && (
          <Text size="xs" c="bright" style={{ whiteSpace: 'pre-wrap' }}>
            {feedback.comment}
          </Text>
        )}
      </Stack>
    </Group>
  );
};
